export class SpecialCircumstances {
    
    HadCovid19Vaccination: boolean | null;
    Covid19VaccinesTaken: string;

    IsDisabled: boolean;
    DisabledDescription: string;
    WasHospitalised: boolean;
    HospitalisedDescription: string;
    HasMedicalHistory: boolean;
    MedicalHistoryDescription: string;
    HadViolentBehaviour: boolean;
    ViolentBehaviourDescription: string;
    WasSuspended: boolean;
    SuspensionDueToViolenceToPerson: boolean;
    SuspensionDueToIllegalDrugs: boolean;
    SuspensionDueToWeaponPossession: boolean;
    SuspensionDueToViolenceAtSchool: boolean;
    SuspendedDueToOtherReason: boolean;
    OtherReasonForSuspension: boolean;
    InvolvedInOtherIncidentsOutsideSchool: boolean;
    OtherIncidentsDescription: string;

    OtherDisabilitiesNotListed: string;
    AnyModificationsDoneAtHome: boolean;
    DetailsOfModificationAndStrategies: string;
    SpecificImpairmentsOrDisabilities: string;
}
